import React, { useState } from "react";
import LoginLayout from "../../components/Login";

export default function SupervisorLogin() {

  return (
    <div className="min-h-screen flex items-center justify-center bg-black">
     <LoginLayout role={"Supervisor"} />
    </div>
  );
}
